import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=62b55354&scoped=true"
import script from "./DataTable.vue?vue&type=script&lang=js"
export * from "./DataTable.vue?vue&type=script&lang=js"
import style0 from "./DataTable.vue?vue&type=style&index=0&id=62b55354&prod&scoped=true&lang=css"
import style1 from "./DataTable.vue?vue&type=style&index=1&id=62b55354&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b55354",
  null
  
)

export default component.exports